import * as React from 'react'
import { View, Text, TextProps, Platform, DimensionValue } from 'react-native'

type Props = {
  lineHeight: number
  style?: Omit<TextProps['style'], 'fontSize'> & { fontSize: number }
  children?: React.ReactNode
} & TextProps

export function FixedText(props: Props) {
  const { style, children, ...restProps } = props

  const lineHeight = props.lineHeight || 1.5
  const fontSize = props.style?.fontSize || 16

  return (
    <Text {...restProps}>
      <View
        style={{
          height: 0,
          width: 0,
          display: Platform.select({
            web: 'block',
            default: undefined,
          }),
          marginTop: Platform.select<DimensionValue | string>({
            web: `calc((1 - ${lineHeight}) * 0.5em)`,
            native: (1 - lineHeight) * (0.5 * fontSize),
          }),
        }}
      />
      <Text
        style={[style, { lineHeight }]}
        {...{ numberOfLines: props.numberOfLines || undefined }}
      >
        {children}
      </Text>
    </Text>
  )
}
